import { render, staticRenderFns } from "./Heji.vue?vue&type=template&id=22f6f7c9&scoped=true"
import script from "./Heji.vue?vue&type=script&lang=js"
export * from "./Heji.vue?vue&type=script&lang=js"
import style0 from "./Heji.vue?vue&type=style&index=0&id=22f6f7c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6f7c9",
  null
  
)

export default component.exports